// extracted by mini-css-extract-plugin
export default {"root":"FileIcon_root__nRZsc"};